/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileSummaryModel } from '../../models/profile-summary-model';
import { SummaryRequestModel } from '../../models/summary-request-model';

export interface ExternalSummaryProfileIdPost$Params {

/**
 * The member profile identifier.
 */
  profileId: string;
  
    /**
     * The summary request containing the reference `SummaryDate`.
     */
    body?: SummaryRequestModel
}

export function externalSummaryProfileIdPost(http: HttpClient, rootUrl: string, params: ExternalSummaryProfileIdPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<ProfileSummaryModel>> {
  const rb = new RequestBuilder(rootUrl, externalSummaryProfileIdPost.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<ProfileSummaryModel>;
    })
  );
}

externalSummaryProfileIdPost.PATH = '/External/Summary/{profileId}';
